import React, { useState, useEffect } from 'react';
import './styles.css';
import './styles-additional.css';
import { departmentOptions, gradeOptions, roleOptions, gradeMapByRole } from './dropdownOptions';
// Update this import to include getRoles
import { 
  getEmployeeTypes, 
  getDesignations, 
  addUser, 
  getDepartments, 
  getRoles, 
  getLevels,
  getCountries, // Add this import
  verifyUserId, // Add this import
  getLeaveTypes // Add this import
} from '../../../Action/api';
import CloseIcon from '@mui/icons-material/Close';
import BusinessIcon from '@mui/icons-material/Business';
import BadgeIcon from '@mui/icons-material/Badge';
import GradeIcon from '@mui/icons-material/Grade';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CircularProgress from '@mui/icons-material/LoopOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CelebrationIcon from '@mui/icons-material/Celebration';
import CancelIcon from '@mui/icons-material/Cancel';
import { departmentTemplates, getDepartmentIcon } from './departmentTemplates';

const CreatePeople = () => {
  const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0];

  // Update formData to include workingCountry
  const [formData, setFormData] = useState({
    workingCountry: '', // Add this new field
    name: '',
    department: '',
    grade: '',
    role: '',
    username: '',
    location: '',
    joinDate: today,
    level: '',
    email: '',
    phoneNumber: '',
    jobDescription: '',
    manager: '',
    employeeType: '',
    designation: '',
    // Other fields
    gender: '',
    maritalStatus: '', // Add this new field
    dateOfBirth: '',
    currentAddress: '',
    permanentAddress: '',
    nationality: '',
    governmentId: '',
    bloodGroup: '',
    hobbies: '',
    yourPassion: '',
    shortTermGoal: '',
    longTermGoal: '',
    primaryLanguage: '',
    knownLanguage: '',
    // Leave fields
    allocatedAnnualLeave: 10,
    allocatedEmergencyLeave: 3,
    allocatedSickLeave: 4,
    allocatedMaternityLeave: 0, // Add this field for female employees
    allocatedUnpaidLeave: 0, // Add this field for all employees
    workLocation: '',
    joiningDate: today,
    probationPeriod: '3 Month', // Default probation period
  });
  
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [showTemplateApplied, setShowTemplateApplied] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [templatePreview, setTemplatePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    show: false,
    success: false,
    message: ''
  });
  
  // New state variables for API data
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [roles, setRoles] = useState([]); // Add state for roles from API
  const [levels, setLevels] = useState([]);
  const [countries, setCountries] = useState([]); // Add state for countries
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [isLoadingDropdowns, setIsLoadingDropdowns] = useState(false);
  const [isLoadingLeaves, setIsLoadingLeaves] = useState(false);

  // Add these state variables to your component
  const [showSubmitConfirmation, setShowSubmitConfirmation] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState({
    isSubmitting: false,
    isComplete: false,
    isSuccess: false,
    message: '',
    details: []
  });
  
  // New state for reporting manager ID validation
  const [reportingManagerId, setReportingManagerId] = useState('');
  const [reportingManagerStatus, setReportingManagerStatus] = useState({
    isValidating: false,
    isValid: null,
    message: ''
  });

  // Fetch employee types and designations when component mounts
  useEffect(() => {
    const fetchDropdownData = async () => {
      setIsLoadingDropdowns(true);
      try {
        // Fetch employee types
        const empTypes = await getEmployeeTypes();
        setEmployeeTypes(empTypes);
        
        // Fetch designations
        const desgs = await getDesignations();
        setDesignations(desgs);
        
        // Fetch departments
        const deps = await getDepartments();
        setDepartments(deps);
        
        // Fetch roles
        const roleData = await getRoles();
        setRoles(roleData);
        
        // Fetch levels
        const levelData = await getLevels();
        setLevels(levelData);
        
        // Fetch countries
        const countryData = await getCountries();
        setCountries(countryData);
        
        // Log for debugging
        console.log('API Country data:', countryData);
        
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      } finally {
        setIsLoadingDropdowns(false);
      }
    };

    fetchDropdownData();
  }, []);

  // Add this function to fetch leave data based on country selection
  const fetchLeaveData = async (countryCode) => {
    if (!countryCode) return;
    
    setIsLoadingLeaves(true);
    console.log('Fetching leave data for country code:', countryCode);
    
    try {
      const leaveData = await getLeaveTypes(countryCode);
      console.log('Raw leave data response:', leaveData);
      
      // Check data structure and extract the array if needed
      const leaveArray = Array.isArray(leaveData) ? leaveData : 
                        (leaveData && leaveData.data && Array.isArray(leaveData.data)) ? 
                        leaveData.data : [];
      
      console.log('Processed leave array:', leaveArray);
      setLeaveTypes(leaveArray);
      
      // Update form data with defaults from API
      if (leaveArray.length > 0) {
        const annualLeave = leaveArray.find(leave => leave.leaveName === 'Annual Leave');
        const emergencyLeave = leaveArray.find(leave => leave.leaveName === 'Emergency Leave');
        const sickLeave = leaveArray.find(leave => leave.leaveName === 'Sick Leave');
        const maternityLeave = leaveArray.find(leave => leave.leaveName === 'Maternity Leave');
        const unpaidLeave = leaveArray.find(leave => leave.leaveName === 'Unpaid Leave');
        
        console.log('Found leave types:', { annualLeave, emergencyLeave, sickLeave, maternityLeave, unpaidLeave });
        
        setFormData(prev => ({
          ...prev,
          allocatedAnnualLeave: annualLeave ? parseInt(annualLeave.leaveCount) : 10,
          allocatedEmergencyLeave: emergencyLeave ? parseInt(emergencyLeave.leaveCount) : 3,
          allocatedSickLeave: sickLeave ? parseInt(sickLeave.leaveCount) : 4,
          allocatedMaternityLeave: maternityLeave ? parseInt(maternityLeave.leaveCount) : 0,
          allocatedUnpaidLeave: unpaidLeave ? parseInt(unpaidLeave.leaveCount) : 0
        }));
      }
    } catch (error) {
      console.error('Error fetching leave data:', error);
      setLeaveTypes([]);
    } finally {
      setIsLoadingLeaves(false);
    }
  };

  // Change the useEffect to fetch leave data when workingCountry changes instead of nationality
  useEffect(() => {
    if (formData.workingCountry) {
      const selectedCountry = countries.find(country => country.countryName === formData.workingCountry);
      if (selectedCountry) {
        console.log('Fetching leave data for country:', selectedCountry.countryCode);
        fetchLeaveData(selectedCountry.countryCode);
      }
    }
  }, [formData.workingCountry, countries]);

  // Modify the handleChange function to also consider gender when selecting leave types
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'department' ? { role: '', designation: '' } : {})  // Reset designation when department changes
    }));
    
    // If nationality changes, we'll trigger the useEffect to fetch leave data
  };

  // Update filtered roleOptions to use API data
  const filteredRoleOptions = formData.department 
    ? roles.filter(role => role.depId === formData.department)
    : [];

  // Updated logic to find selected role label from API data
  const selectedRole = roles.find(role => role.roleId === formData.role);
  const selectedRoleLabel = selectedRole?.roleName || '';

  // Filter grade options based on selected role
  const filteredGradeOptions = selectedRoleLabel && gradeMapByRole[selectedRoleLabel]
    ? gradeOptions.filter(opt => gradeMapByRole[selectedRoleLabel].includes(opt.value) || opt.value === '')
    : gradeOptions;

  // Add a new variable to filter designations based on selected department
  const filteredDesignations = formData.department 
    ? designations.filter(des => des.depId === formData.department)
    : [];

  // Add debugging to help track the matching issue (you can remove this later)
  useEffect(() => {
    if (formData.department && designations.length > 0) {
      console.log('Selected department ID:', formData.department);
      console.log('Available designations depIds:', designations.map(des => des.depId));
      console.log('Filtered designations:', filteredDesignations);
    }
  }, [formData.department, designations, filteredDesignations]);

  // Add debugging for role filtering
  useEffect(() => {
    if (formData.department && roles.length > 0) {
      console.log('Selected department ID:', formData.department);
      console.log('Available roles:', roles);
      console.log('Roles depIds:', roles.map(role => role.depId));
      console.log('Filtered roles:', filteredRoleOptions);
    }
  }, [formData.department, roles, filteredRoleOptions]);

  // Add this debugging effect to compare department IDs
  useEffect(() => {
    if (departments.length > 0 && roles.length > 0) {
      console.log('Department IDs in dropdown:', departments.map(d => d.depId));
      console.log('Department IDs in roles:', [...new Set(roles.map(r => r.depId))]);
      
      // Check for any matches
      const depIds = departments.map(d => d.depId);
      const roleDepIds = [...new Set(roles.map(r => r.depId))];
      const matches = depIds.filter(id => roleDepIds.includes(id));
      console.log('Matching department IDs:', matches);
    }
  }, [departments, roles]);

  // Add this useEffect to debug template application
  useEffect(() => {
    if (formData.department && roles.length > 0) {
      console.log('Current form data:', formData);
      console.log('Available roles for current department:', 
        roles.filter(role => role.depId === formData.department));
    }
  }, [formData.department, roles]);

  // Validate all required fields are filled
  const validateForm = () => {
    const requiredFields = [
      'name', 'department', 'grade', 'role', 'username', 
      'workLocation', 'joiningDate', 'probationPeriod',
      'level', 'email', 'employeeType',
      'dateOfBirth', 'nationality', 'gender', 'maritalStatus'
    ];
    
    const missingFields = requiredFields.filter(field => !formData[field]);
    
    // Check if reporting manager is valid and present
    if (!reportingManagerId || reportingManagerStatus.isValid !== true) {
      return false;
    }
    
    return missingFields.length === 0;
  };

  // Format data for API submission
  const formatPayload = () => {
    // Get the department name
    const selectedDepartment = departments.find(dept => dept.depId === formData.department);
    const departmentName = selectedDepartment?.depName || '';
    
    // Get the role name
    const selectedRole = roles.find(role => role.roleId === formData.role);
    const roleName = selectedRole?.roleName || '';
    
    // Get the employee type data
    const selectedEmpType = employeeTypes.find(type => type.empTypeId === formData.employeeType);
    
    // Get the designation data
    const selectedDes = designations.find(des => des.desId === formData.designation);
    
    // Get the level data
    const selectedLevel = levels.find(level => level.levelId === formData.level);
    
    // Generate a temporary user ID if none exists
    const tempUserId = `user-${Date.now().toString().substring(8)}`;
    
    // Get the current year
    const currentYear = new Date().getFullYear().toString();
    
    return {
      userId: formData.username || tempUserId,
      password: "Default@123", // Default password, should be changed later
      depId: formData.department,
      depName: departmentName,
      roleId: formData.role,
      roleName: roleName,
      empTypeId: selectedEmpType?.empTypeId || "None",
      empTypeName: selectedEmpType?.empTypeName || "None",
      levelId: formData.level,
      levelName: selectedLevel?.levelName || "None",
      desId: selectedDes?.desId || "None",
      desName: selectedDes?.desName || "None",
      reportingMngId: reportingManagerStatus.isValid ? reportingManagerId : "None",
      reportingManagerName: reportingManagerStatus.isValid ? reportingManagerStatus.managerName : "None",
      grade: formData.grade,
      staffFullName: formData.name,
      gender: formData.gender, // Required field now, no fallback needed
      maritalStatus: formData.maritalStatus, // Required field now, no fallback needed
      dateOfBirth: formData.dateOfBirth || "None",
      contactNumber: formData.phoneNumber || "None",
      personalEmail: formData.email,
      currentAddress: formData.currentAddress || "None",
      permanentAddress: formData.permanentAddress || "None",
      nationality: formData.nationality || "None",
      governmentId: formData.governmentId || "None",
      joiningDate: formData.joiningDate || today,
      workLocation: formData.workLocation || "None",
      probationPeriod: formData.probationPeriod || "3 Month",
      bloodGroup: formData.bloodGroup || "None",
      hobbies: formData.hobbies || "None",
      yourPassion: formData.yourPassion || "None",
      shortTermGoal: formData.shortTermGoal || "None",
      longTermGoal: formData.longTermGoal || "None",
      primaryLanguage: formData.primaryLanguage || "None",
      knownLanguage: formData.knownLanguage || "None",
      // Add the missing fields with defaults
      staffStatus: "Active", // Default value
      currentYear: currentYear, // Current year
      allocatedAnnualLeave: formData.allocatedAnnualLeave, // From form
      allocatedEmergencyLeave: formData.allocatedEmergencyLeave, // From form
      allocatedSickLeave: formData.allocatedSickLeave, // From form
      allocatedUnpaidLeave: formData.allocatedUnpaidLeave, // Add unpaid leave
      // Only add maternity leave for female employees
      ...(formData.gender === 'Female' ? { allocatedMaternityLeave: formData.allocatedMaternityLeave } : {})
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check for reporting manager first
    if (!reportingManagerId) {
      setSubmitStatus({
        show: true,
        success: false,
        message: 'Please enter a Reporting Manager ID.'
      });
      setTimeout(() => setSubmitStatus({ show: false, success: false, message: '' }), 5000);
      return;
    }
    
    // Check if reporting manager is valid
    if (reportingManagerStatus.isValid !== true) {
      setSubmitStatus({
        show: true,
        success: false,
        message: 'Please enter a valid Reporting Manager ID.'
      });
      setTimeout(() => setSubmitStatus({ show: false, success: false, message: '' }), 5000);
      return;
    }
    
    // Continue with other validations
    if (!validateForm()) {
      setSubmitStatus({
        show: true,
        success: false,
        message: 'Please fill in all required fields.'
      });
      setTimeout(() => setSubmitStatus({ show: false, success: false, message: '' }), 5000);
      return;
    }
    
    // Show confirmation dialog instead of submitting directly
    setShowSubmitConfirmation(true);
  };

  // Make sure this confirmation dialog component is present in your return JSX

  // New function to handle the actual submission after confirmation
  const handleConfirmedSubmit = async () => {
    // Format data for API submission
    const payload = formatPayload();
    
    // Close confirmation dialog and start loading state
    setShowSubmitConfirmation(false);
    setSubmissionStatus({
      isSubmitting: true,
      isComplete: false,
      isSuccess: false,
      message: 'Processing onboarding request...',
      details: ['Validating information', 'Preparing data for submission']
    });
    
    try {
      // Simulate steps with timeouts for better UX
      setTimeout(() => {
        setSubmissionStatus(prev => ({
          ...prev,
          details: [...prev.details, 'Creating user account']
        }));
      }, 800);
      
      setTimeout(() => {
        setSubmissionStatus(prev => ({
          ...prev,
          details: [...prev.details, 'Setting up permissions']
        }));
      }, 1600);
      
      // Use the API service to add the user
      await addUser(payload);
      
      setTimeout(() => {
        setSubmissionStatus(prev => ({
          ...prev,
          details: [...prev.details, 'Finalizing onboarding process']
        }));
      }, 2200);
      
      // Show success state
      setTimeout(() => {
        setSubmissionStatus({
          isSubmitting: false,
          isComplete: true,
          isSuccess: true,
          message: 'Staff member successfully onboarded!',
          details: ['User account created', 'Onboarding process complete', 'Welcome email scheduled']
        });
      }, 2800);
      
      // Reset form after delay
      setTimeout(() => {
        // Reset form
        setFormData({
          workingCountry: '', // Reset working country
          name: '',
          department: '',
          grade: '',
          role: '',
          username: '',
          location: '',
          joinDate: today,
          level: '',
          email: '',
          phoneNumber: '',
          jobDescription: '',
          manager: '',
          employeeType: '',
          designation: '',
          // Reset the new fields
          dateOfBirth: '',
          contactNumber: '',
          personalEmail: '',
          currentAddress: '',
          permanentAddress: '',
          nationality: '',
          governmentId: '',
          probationPeriod: '3 months',
          bloodGroup: '',
          hobbies: '',
          yourPassion: '',
          shortTermGoal: '',
          longTermGoal: '',
          primaryLanguage: '',
          knownLanguage: ''
        });
        
        setSelectedTemplate('');
        
        // Reset checkboxes
        document.getElementById('emailSetup').checked = false;
        document.getElementById('accessCard').checked = false;
        document.getElementById('itEquipment').checked = false;
        document.getElementById('workstation').checked = false;
        document.getElementById('systemAccess').checked = false;
        document.getElementById('orientation').checked = false;
        
        // Close the submission dialog
        setTimeout(() => {
          setSubmissionStatus(prev => ({
            ...prev,
            isComplete: false
          }));
        }, 2000);
        
      }, 4000);
      
    } catch (error) {
      console.error('Onboarding submission error:', error);
      
      // Show error state
      setSubmissionStatus({
        isSubmitting: false,
        isComplete: true,
        isSuccess: false,
        message: 'Onboarding process failed',
        details: [`Error: ${error.message || 'Unknown error occurred'}`, 'Please try again']
      });
    }
  };

  // Function to close the submission dialog
  const handleCloseSubmissionDialog = () => {
    if (!submissionStatus.isSubmitting) {
      setSubmissionStatus(prev => ({
        ...prev,
        isComplete: false
      }));
    }
  };

  // Preview a template with enhanced data
  const handlePreviewTemplate = (templateId) => {
    if (templateId && departmentTemplates[templateId]) {
      const template = departmentTemplates[templateId];
      
      // Find matching department from API data
      const matchingDept = departments.find(d => 
        // Try exact match first
        d.depId === templateId ||
        // If no exact match, try to match by name
        d.depName.toLowerCase() === departmentOptions.find(opt => opt.value === templateId)?.label.toLowerCase()
      );
      
      // If we found a matching department, use its name, otherwise fall back to template options
      const deptName = matchingDept ? matchingDept.depName : 
        departmentOptions.find(opt => opt.value === templateId)?.label || '';
      
      // Find role name - try to use API data if available
      let roleName = '';
      if (roles.length > 0 && matchingDept) {
        // Look for any roles in this department
        const deptRoles = roles.filter(role => role.depId === matchingDept.depId);
        if (deptRoles.length > 0) {
          roleName = deptRoles[0].roleName; // Use the first role as default
        }
      } else {
        // Fall back to the old role mapping if API data isn't available
        roleName = roleOptions.find(opt => 
          opt.value === template.defaultRole && opt.department === templateId
        )?.label || '';
      }
      
      setTemplatePreview({
        id: templateId,
        name: deptName,
        role: roleName,
        grade: template.defaultGrade,
        level: template.defaultLevel,
        location: template.defaultLocation,
        description: template.description,
        requiredSkills: template.requiredSkills || [],
        equipment: template.equipment || [],
        softwareAccess: template.softwareAccess || [],
        onboardingDuration: template.onboardingDuration || "2 weeks",
        color: template.color
      });
    }
  };
  
  // Apply template with enhanced data
  const applyTemplate = (templateId) => {
    if (templateId && departmentTemplates[templateId]) {
      const template = departmentTemplates[templateId];
      
      // Find the matching department from the API data
      const matchingDept = departments.find(d => 
        // Try exact match first
        d.depId === templateId ||
        // If no exact match, try to match by name
        d.depName.toLowerCase() === departmentOptions.find(opt => opt.value === templateId)?.label.toLowerCase()
      );
      
      // If we found a matching department, use its ID, otherwise fall back to template ID
      const departmentId = matchingDept ? matchingDept.depId : templateId;
      
      // Find a matching role for this department
      let roleId = '';
      if (roles.length > 0) {
        const deptRoles = roles.filter(role => role.depId === departmentId);
        if (deptRoles.length > 0) {
          roleId = deptRoles[0].roleId; // Use first role as default
        }
      }
      
      // Find the matching level from the API data
      let levelId = '';
      if (levels.length > 0) {
        const matchingLevel = levels.find(level => 
          level.levelName === template.defaultLevel
        );
        if (matchingLevel) {
          levelId = matchingLevel.levelId;
        } else {
          // If no exact match, use the first level as fallback
          levelId = levels[0]?.levelId || '';
        }
      }
      
      // Get a default employee type if available
      let employeeTypeId = '';
      if (employeeTypes.length > 0) {
        // Look for full-time employee type as default
        const fullTimeType = employeeTypes.find(type => 
          type.empTypeName.toLowerCase().includes('full-time') || 
          type.empTypeName.toLowerCase().includes('permanent')
        );
        
        if (fullTimeType) {
          employeeTypeId = fullTimeType.empTypeId;
        } else {
          // Fall back to first employee type
          employeeTypeId = employeeTypes[0]?.empTypeId || '';
        }
      }
      
      // Find a suitable designation for this department
      let designationId = '';
      if (designations.length > 0) {
        const deptDesignations = designations.filter(des => des.depId === departmentId);
        if (deptDesignations.length > 0) {
          // Try to find a designation that matches template role name
          const matchingDesignation = deptDesignations.find(des => 
            des.desName.toLowerCase().includes(template.role?.toLowerCase() || '')
          );
          
          if (matchingDesignation) {
            designationId = matchingDesignation.desId;
          } else {
            // Fall back to first designation
            designationId = deptDesignations[0]?.desId || '';
          }
        }
      }
      
      // Generate template-based sample data for non-personal fields
      const deptName = matchingDept?.depName || departmentOptions.find(opt => opt.value === templateId)?.label || '';
      
      // Update form data with complete template values EXCEPT for specified personal fields
      setFormData(prev => ({
        ...prev,
        // Department & Role info
        department: departmentId,
        role: roleId,
        grade: template.defaultGrade || prev.grade,
        level: levelId,
        employeeType: employeeTypeId,
        designation: designationId,
        location: template.defaultLocation || prev.location,
        manager: template.defaultManager || prev.manager,
        
        // Job details
        jobDescription: `${template.description}\n\nRequired Skills: ${template.requiredSkills?.join(', ')}`,
        
        // Personal Development (these are filled by template)
        hobbies: template.suggestedHobbies || "Team activities, professional development",
        yourPassion: template.suggestedPassion || `Contributing to ${deptName} initiatives`,
        shortTermGoal: template.suggestedShortTermGoal || `Mastering ${deptName} processes`,
        longTermGoal: template.suggestedLongTermGoal || `Leadership in ${deptName}`,
        primaryLanguage: template.suggestedLanguage || "English",
        knownLanguage: template.suggestedSecondaryLanguages || "English, plus any additional languages",
        
        // Blood group and addresses (these are filled by template)
        bloodGroup: template.defaultBloodGroup || prev.bloodGroup,
        currentAddress: template.defaultAddress || prev.currentAddress,
        permanentAddress: template.defaultPermanentAddress || prev.permanentAddress,
        
        // KEEP these specific fields unchanged as specified
        // dateOfBirth: prev.dateOfBirth,       // Keep user's value
        // nationality: prev.nationality,       // Keep user's value 
        // governmentId: prev.governmentId,     // Keep user's value
        // email: prev.email                    // Keep user's value
      }));
      
      // Update template state and close modal
      setSelectedTemplate(templateId);
      setTemplatePreview(null);
      setShowTemplateModal(false);
      
      // Show template applied message
      setShowTemplateApplied(true);
      setTimeout(() => setShowTemplateApplied(false), 3000);
    }
  };
  
  // Close preview panel
  const handleClosePreview = () => {
    setTemplatePreview(null);
  };

  // Close modal function
  const handleCloseModal = () => {
    setShowTemplateModal(false);
    setTemplatePreview(null);
  };

  // Handle clicking outside the modal
  const handleOverlayClick = (e) => {
    if (e.target.className === 'template-modal-overlay') {
      handleCloseModal();
    }
  };

  // Use departments from API instead of hardcoded departmentOptions
  // Update the departmentSelectOptions to filter out Chairman and Director departments
  const departmentSelectOptions = departments.length > 0 
    ? departments
        .filter(dept => 
          // Filter out Chairman and Director departments
          !dept.depName.includes('Chariman') && 
          !dept.depName.includes('Director')
        )
        .map(dept => ({
          value: dept.depId, 
          label: dept.depName
        }))
    : departmentOptions.filter(opt => 
        !opt.label.includes('Chairman') && 
        !opt.label.includes('Director')
      ); // Also filter the fallback options

  // Validate manager ID format and existence
  const validateManagerId = async (managerId) => {
    if (!managerId.trim()) {
      setReportingManagerStatus({
        isValidating: false,
        isValid: null,
        message: '', 
        managerName: null
      });
      return;
    }
    
    setReportingManagerStatus({
      isValidating: true,
      isValid: null,
      message: 'Validating...', 
      managerName: null

    });
    
    try {
      const response = await verifyUserId(managerId);
      
      if (response.status && response.exists) {
        setReportingManagerStatus({
          isValidating: false,
          isValid: true,
          message: response.uiMsg || 'Valid User ID', 
          managerName: response.managerName || 'Unknown Manager'  // Store the manager name from the response

        });
        setFormData(prev => ({
          ...prev,
          reportingMngId: managerId
        }));
      } else {
        setReportingManagerStatus({
          isValidating: false,
          isValid: false,
          message: response.uiMsg || 'Invalid User ID', 
          managerName: null

        });
      }
    } catch (error) {
      console.error('Error validating manager ID:', error);
      setReportingManagerStatus({
        isValidating: false,
        isValid: false,
        message: 'Error checking user ID',
        managerName: null
      });
    }
  };

  // Add this before your return statement to properly handle the data structure
  useEffect(() => {
    console.log('Leave types state:', leaveTypes);
    
    // Check if leaveTypes is an object with a data property
    if (leaveTypes && typeof leaveTypes === 'object' && !Array.isArray(leaveTypes) && leaveTypes.data) {
      console.log('Converting leaveTypes object to array:', leaveTypes.data);
      setLeaveTypes(leaveTypes.data);
    }
  }, [leaveTypes]);

  return (
    <div className="create-people-bg">
      <div className="create-people-card">
        <h2 className="create-people-title">HR Onboarding: Add New Staff</h2>
        <p className="create-people-subtitle">
          Please fill in the details below to onboard a new staff member.
        </p>
        
        {/* Template Selection Button */}
        <div className="template-button-wrapper">
          <button 
            onClick={() => setShowTemplateModal(true)}
            className="template-button"
          >
            <span className="material-icons">dashboard</span>
            Choose Department Template
          </button>
          
          {selectedTemplate && (
            <div className="selected-template-indicator" style={{ 
              borderColor: departmentTemplates[selectedTemplate].color 
            }}>
              <div className="template-dot" style={{ 
                backgroundColor: departmentTemplates[selectedTemplate].color 
              }}></div>
              {departments.find(d => d.depId === formData.department)?.depName || 
               departmentOptions.find(opt => opt.value === selectedTemplate)?.label} Template Active
            </div>
          )}
        </div>
          
        {/* Template Applied Message */}
        {showTemplateApplied && (
          <div className="template-success-message">
            <span className="material-icons">check_circle</span>
            Template applied successfully!
          </div>
        )}
        
        {/* Form Submit Status Message */}
        {submitStatus.show && (
          <div className={`form-status-message ${submitStatus.success ? 'success' : 'error'}`}>
            {submitStatus.success ? <CheckCircleIcon /> : <ErrorIcon />}
            {submitStatus.message}
          </div>
        )}
        
        {/* Original Form Layout */}
        <form onSubmit={handleSubmit} className="create-people-form">
          <div className="form-section">
            <div className="section-header">
              <BusinessIcon />
              <h3>Department & Role Information</h3>
            </div>
            
            <div className="section-content">
              {/* Add Working Country at the top */}
              <div className="form-field">
                <label>Working Country <span className="required-star">*</span></label>
                <select
                  name="workingCountry"
                  value={formData.workingCountry}
                  onChange={handleChange}
                  required
                  disabled={isLoadingDropdowns}
                >
                  <option value="">Select Working Country</option>
                  {countries.map(country => (
                    <option key={country.countryCode} value={country.countryName}>
                      {country.countryName}
                    </option>
                  ))}
                </select>
                {isLoadingDropdowns && <span className="loading-indicator">Loading countries...</span>}
              </div>
              
              <div className="form-field">
                <label>Department <span className="required-star">*</span></label>
                <select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  required
                  disabled={isLoadingDropdowns}
                >
                  <option value="">Select Department</option>
                  {departmentSelectOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
                {isLoadingDropdowns && <span className="loading-indicator">Loading departments...</span>}
              </div>
              
              <div className="form-field">
                <label>Role <span className="required-star">*</span></label>
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  required
                  disabled={!formData.department || isLoadingDropdowns}
                >
                  <option value="">Select Role</option>
                  {filteredRoleOptions.length > 0 ? (
                    filteredRoleOptions.map(role => (
                      <option key={role.roleId} value={role.roleId}>
                        {role.roleName}
                      </option>
                    ))
                  ) : (
                    formData.department && !isLoadingDropdowns && (
                      <option value="" disabled>No roles available</option>
                    )
                  )}
                </select>
                {isLoadingDropdowns && (
                  <span className="loading-indicator">Loading roles...</span>
                )}
                {!isLoadingDropdowns && formData.department && filteredRoleOptions.length === 0 && (
                  <span className="no-data-message">
                    No roles available for this department
                  </span>
                )}
              </div>
              
              <div className="form-field">
                <label>Grade <span className="required-star">*</span></label>
                <select
                  name="grade"
                  value={formData.grade}
                  onChange={handleChange}
                  required
                  disabled={!formData.role}
                >
                  {filteredGradeOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              
              <div className="form-field">
                <label>Level <span className="required-star">*</span></label>
                <select
                  name="level"
                  value={formData.level}
                  onChange={handleChange}
                  required
                  disabled={isLoadingDropdowns}
                >
                  <option value="">Select Level</option>
                  {levels
                    .filter(level => 
                      !level.levelName.includes('Owner/Founder') && 
                      !level.levelName.includes('Owner')
                    )
                    .map(level => (
                      <option key={level.levelId} value={level.levelId}>
                        {level.levelName}
                      </option>
                    ))
                  }
                </select>
                {isLoadingDropdowns && <span className="loading-indicator">Loading levels...</span>}
              </div>
              
              {/* New Employee Type Dropdown */}
              <div className="form-field">
                <label>Employee Type <span className="required-star">*</span></label>
                <select
                  name="employeeType"
                  value={formData.employeeType}
                  onChange={handleChange}
                  required
                  disabled={isLoadingDropdowns}
                >
                  <option value="">Select Employee Type</option>
                  {employeeTypes.map(type => (
                    <option key={type.empTypeId} value={type.empTypeId}>
                      {type.empTypeName}
                    </option>
                  ))}
                </select>
                {isLoadingDropdowns && <span className="loading-indicator">Loading...</span>}
              </div>

              {/* New Designation Dropdown with enhanced feedback */}
              <div className="form-field">
                <label>Designation</label>
                <select
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  disabled={isLoadingDropdowns || !formData.department}
                >
                  <option value="">Select Designation</option>
                  {filteredDesignations.length > 0 ? (
                    filteredDesignations.map(des => (
                      <option key={des.desId} value={des.desId}>
                        {des.desName}
                      </option>
                    ))
                  ) : (
                    formData.department && !isLoadingDropdowns && (
                      <option value="" disabled>No designations available</option>
                    )
                  )}
                </select>
                {isLoadingDropdowns && (
                  <span className="loading-indicator">Loading designations...</span>
                )}
                {!isLoadingDropdowns && formData.department && filteredDesignations.length === 0 && (
                  <span className="no-data-message">
                    No designations available for this department
                  </span>
                )}
              </div>
            </div>
          </div>
          
          <div className="form-section">
            <div className="section-header">
              <BadgeIcon />
              <h3>Personal Information</h3>
            </div>
            
            <div className="section-content">
              <div className="form-field">
                <label>Full Name <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="First and Last Name"
                />
              </div>
              
              <div className="form-field">
                <label>Username <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  placeholder="System Username"
                />
              </div>
              
              <div className="form-field">
                <label>Email <span className="required-star">*</span></label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Work Email"
                />
              </div>
              
              <div className="form-field">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Work Phone Number"
                />
              </div>

              {/* Update Gender dropdown to be required */}
              <div className="form-field">
                <label>Gender <span className="required-star">*</span></label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                  <option value="Prefer not to say">Prefer not to say</option>
                </select>
              </div>
              
              {/* Update Marital Status dropdown to be required */}
              <div className="form-field">
                <label>Marital Status <span className="required-star">*</span></label>
                <select
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Marital Status</option>
                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Divorced">Divorced</option>
                  <option value="Widowed">Widowed</option>
                  <option value="Separated">Separated</option>
                </select>
              </div>
              
              {/* Add Date of Birth */}
              <div className="form-field">
                <label>Date of Birth <span className="required-star">*</span></label>
                <input
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  required
                  max={new Date().toISOString().split('T')[0]}
                />
              </div>
            </div>
          </div>
          
          <div className="form-section">
            <div className="section-header">
              <LocationOnIcon />
              <h3>Work Details</h3>
            </div>
            
            <div className="section-content">
              <div className="form-field">
                <label>Work Location <span className="required-star">*</span></label>
                <input
                  type="text"
                  name="workLocation"
                  value={formData.workLocation}
                  onChange={handleChange}
                  required
                  placeholder="Office location (e.g., Bangalore, Remote)"
                />
              </div>
              
              <div className="form-field">
                <label>Joining Date <span className="required-star">*</span></label>
                <input
                  type="date"
                  name="joiningDate"
                  value={formData.joiningDate}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-field">
                <label>Probation Period <span className="required-star">*</span></label>
                <select
                  name="probationPeriod"
                  value={formData.probationPeriod}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Probation Period</option>
                  <option value="1 Month">1 Month</option>
                  <option value="2 Month">2 Month</option>
                  <option value="3 Month">3 Month</option>
                  <option value="4 Month">4 Month</option>
                  <option value="5 Month">5 Month</option>
                  <option value="6 Month">6 Month</option>
                </select>
              </div>

              {/* Reporting Manager ID field */}
              <div className="form-field">
                <label>Reporting Manager <span className="required-star">*</span></label>
                <div className="input-validation-wrapper">
                  <input
                    type="text"
                    name="reportingMngId"
                    value={reportingManagerId}
                    onChange={(e) => setReportingManagerId(e.target.value)}
                    onBlur={() => validateManagerId(reportingManagerId)}
                    placeholder="Manager's User ID"
                    required
                  />
                  {reportingManagerStatus.isValidating && (
                    <span className="validation-message validating">
                      <span className="spinner-icon"></span> Validating...
                    </span>
                  )}
                  {!reportingManagerStatus.isValidating && reportingManagerStatus.isValid === true && (
                    <span className="validation-message valid">
                      <span className="material-icons">check_circle</span> {reportingManagerStatus.message}
                    </span>
                  )}
                  {!reportingManagerStatus.isValidating && reportingManagerStatus.isValid === false && (
                    <span className="validation-message invalid">
                      <span className="material-icons">error</span> {reportingManagerStatus.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          {/* Add a NEW Section for Additional Personal Details */}
          <div className="form-section">
            <div className="section-header">
              <span className="material-icons">contact_mail</span>
              <h3>Contact & Identity Details</h3>
            </div>
            
            <div className="section-content">
              {/* Keep Nationality dropdown but with updated description */}
              <div className="form-field">
                <label>Nationality <span className="required-star">*</span></label>
                <select
                  name="nationality"
                  value={formData.nationality}
                  onChange={handleChange}
                  required
                  disabled={isLoadingDropdowns}
                >
                  <option value="">Select Nationality</option>
                  {countries.map(country => (
                    <option key={country.countryCode} value={country.countryName}>
                      {country.countryName}
                    </option>
                  ))}
                </select>
                {isLoadingDropdowns && <span className="loading-indicator">Loading countries...</span>}
                <div className="field-note small">
                  <span className="material-icons info-icon-small">info</span>
                  <span>The employee's citizenship, different from Working Country.</span>
                </div>
              </div>

              {/* Add Government ID */}
              <div className="form-field">
                <label>Government ID</label>
                <input
                  type="text"
                  name="governmentId"
                  value={formData.governmentId}
                  onChange={handleChange}
                  placeholder="ID Number (SSN, Passport, etc.)"
                />
              </div>

              {/* Add Current Address */}
              <div className="form-field full-width">
                <label>Current Address</label>
                <textarea
                  name="currentAddress"
                  value={formData.currentAddress}
                  onChange={handleChange}
                  placeholder="Current Residential Address"
                  rows={2}
                  style={{
                    width: '100%',
                    resize: 'vertical',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              {/* Add Permanent Address */}
              <div className="form-field full-width">
                <label>Permanent Address</label>
                <textarea
                  name="permanentAddress"
                  value={formData.permanentAddress}
                  onChange={handleChange}
                  placeholder="Permanent Residential Address"
                  rows={4}
                  style={{
                    width: '100%',
                    minHeight: '100px',
                    resize: 'vertical',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              {/* Add Blood Group */}
              <div className="form-field">
                <label>Blood Group</label>
                <select
                  name="bloodGroup"
                  value={formData.bloodGroup}
                  onChange={handleChange}
                >
                  <option value="">Select Blood Group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
              </div>
            </div>
          </div>

          {/* Add a NEW Section for Personal Development */}
          <div className="form-section">
            <div className="section-header">
              <span className="material-icons">psychology</span>
              <h3>Personal Development</h3>
            </div>
            
            <div className="section-content">
              {/* Add Hobbies as textarea with same styling as Permanent Address */}
              <div className="form-field full-width">
                <label>Hobbies</label>
                <textarea
                  name="hobbies"
                  value={formData.hobbies}
                  onChange={handleChange}
                  placeholder="Hobbies & Interests"
                  rows={4}
                  style={{
                    width: '100%',
                    minHeight: '100px',
                    resize: 'vertical',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              {/* Update Passion to textarea with same styling as Permanent Address */}
              <div className="form-field full-width">
                <label>Passion</label>
                <textarea
                  name="yourPassion"
                  value={formData.yourPassion}
                  onChange={handleChange}
                  placeholder="What are you passionate about?"
                  rows={4}
                  style={{
                    width: '100%',
                    minHeight: '100px',
                    resize: 'vertical',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              {/* Update Short Term Goal to textarea with same styling as Permanent Address */}
              <div className="form-field full-width">
                <label>Short Term Goal</label>
                <textarea
                  name="shortTermGoal"
                  value={formData.shortTermGoal}
                  onChange={handleChange}
                  placeholder="Short-term career goals"
                  rows={4}
                  style={{
                    width: '100%',
                    minHeight: '100px',
                    resize: 'vertical',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              {/* Update Long Term Goal to textarea with same styling as Permanent Address */}
              <div className="form-field full-width">
                <label>Long Term Goal</label>
                <textarea
                  name="longTermGoal"
                  value={formData.longTermGoal}
                  onChange={handleChange}
                  placeholder="Long-term career aspirations"
                  rows={4}
                  style={{
                    width: '100%',
                    minHeight: '100px',
                    resize: 'vertical',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              {/* Add Primary Language */}
              <div className="form-field">
                <label>Primary Language</label>
                <input
                  type="text"
                  name="primaryLanguage"
                  value={formData.primaryLanguage}
                  onChange={handleChange}
                  placeholder="Native or primary language"
                />
              </div>

              {/* Add Known Languages */}
              <div className="form-field">
                <label>Known Languages</label>
                <input
                  type="text"
                  name="knownLanguage"
                  value={formData.knownLanguage}
                  onChange={handleChange}
                  placeholder="Other languages (comma separated)"
                />
              </div>
            </div>
          </div>
          
          <div className="form-section">
            <div className="section-header">
              <span className="material-icons">description</span>
              <h3>Job Details</h3>
            </div>
            
            <div className="section-content">
              <div className="form-field full-width">
                <label>Job Description</label>
                <textarea
                  name="jobDescription"
                  value={formData.jobDescription}
                  onChange={handleChange}
                  placeholder="Brief job description and responsibilities"
                  rows={4}
                />
              </div>
            </div>
          </div>
          
          {/* Replace the Leave Allocation section with this code */}
          <div className="form-section leave-allocation-section">
            <div className="section-header">
              <span className="material-icons">event_available</span>
              <h3>Leave Allocation</h3>
            </div>
            
            <div className="section-content">
              {!formData.workingCountry ? (
                // Show message when no country is selected
                <div className="form-field full-width">
                  <div className="notification-message info">
                    <span className="material-icons">info</span>
                    <span>Please select a working country first to view applicable leave allocations.</span>
                  </div>
                </div>
              ) : isLoadingLeaves ? (
                // Show loading indicator when fetching leave data
                <div className="form-field full-width">
                  <div className="notification-message loading">
                    <span className="spinner-icon"></span>
                    <span>Loading leave types for {formData.workingCountry}...</span>
                  </div>
                </div>
              ) : leaveTypes.length === 0 ? (
                // Show message when no leave types are found for selected country
                <div className="form-field full-width">
                  <div className="notification-message warning">
                    <span className="material-icons">warning</span>
                    <span>No leave allocations found for {formData.workingCountry}. Using default values.</span>
                  </div>
                </div>
              ) : (
                <>
                  <div className="form-field full-width">
                    <div className="leave-header">
                      <h4>Leave Entitlements for {formData.workingCountry}</h4>
                      {formData.gender && (
                        <span className="gender-tag">
                          {formData.gender === 'Male' ? 
                            <span className="material-icons">male</span> : 
                            <span className="material-icons">female</span>}
                          {formData.gender}
                        </span>
                      )}
                    </div>
                    <p className="leave-subtitle">
                      The following leave types are applicable based on {formData.workingCountry} regulations
                      {formData.gender && ` and ${formData.gender.toLowerCase()} employee entitlements`}.
                    </p>
                  </div>
                  
                  {leaveTypes.map(leave => {
                    // Check if this leave type applies to the selected gender
                    const isGenderMatch = 
                      !formData.gender ? true : // Show all if no gender selected
                      leave.leaveGender === "Male/Female" || 
                      (leave.leaveGender === "Male" && formData.gender === "Male") ||
                      (leave.leaveGender === "Female" && formData.gender === "Female") ||
                      (leave.leaveName === "Maternity Leave" && formData.gender === "Female");
                    
                    if (!isGenderMatch) return null;
                    
                    // Determine if this is one of the standard leave types that can be edited
                    const isStandardLeave = 
                      leave.leaveName === "Annual Leave" || 
                      leave.leaveName === "Sick Leave" || 
                      leave.leaveName === "Emergency Leave" ||
                      leave.leaveName === "Unpaid Leave" ||
                      (leave.leaveName === "Maternity Leave" && formData.gender === "Female");
                    
                    // Get the form field name for this leave type
                    const fieldName = 
                      leave.leaveName === "Annual Leave" ? "allocatedAnnualLeave" :
                      leave.leaveName === "Sick Leave" ? "allocatedSickLeave" :
                      leave.leaveName === "Emergency Leave" ? "allocatedEmergencyLeave" :
                      leave.leaveName === "Maternity Leave" ? "allocatedMaternityLeave" :
                      leave.leaveName === "Unpaid Leave" ? "allocatedUnpaidLeave" : null;
                    
                    // Get the current value from form data
                    const currentValue = fieldName ? formData[fieldName] : parseInt(leave.leaveCount);
                    
                    // Determine max value based on leave type
                    const maxValue = 
                      leave.leaveName === "Annual Leave" ? 30 :
                      leave.leaveName === "Maternity Leave" ? 200 :
                      leave.leaveName === "Sick Leave" ? 15 :
                      leave.leaveName === "Emergency Leave" ? 10 : 
                      leave.leaveName === "Unpaid Leave" ? 60 : 20;
                    
                    return (
                      <div className="form-field" key={leave.leaveCode}>
                        <label>
                          {leave.leaveName} 
                          {isStandardLeave && <span className="required-star">*</span>}
                          {leave.leaveGender && leave.leaveGender !== "Male/Female" && (
                            <span className="tag-label gender-specific">
                              {leave.leaveGender} only
                            </span>
                          )}
                        </label>
                        <div className="input-with-label">
                          <input
                            type="number"
                            name={fieldName}
                            value={currentValue}
                            onChange={isStandardLeave ? (e) => {
                              const value = e.target.value === '' ? '' : parseInt(e.target.value);
                              if (value === '' || (!isNaN(value) && value >= 0 && value <= maxValue)) {
                                setFormData(prev => ({ ...prev, [fieldName]: value }));
                              }
                            } : undefined}
                            onBlur={isStandardLeave ? (e) => {
                              const value = e.target.value === '' ? 0 : parseInt(e.target.value);
                              if (isNaN(value) || value < 0) {
                                setFormData(prev => ({ ...prev, [fieldName]: 0 }));
                              } else if (value > maxValue) {
                                setFormData(prev => ({ ...prev, [fieldName]: maxValue }));
                              }
                            } : undefined}
                            min="0"
                            max={maxValue}
                            required={isStandardLeave}
                            disabled={!isStandardLeave || (leave.leaveName === "Maternity Leave" && formData.gender !== "Female")}
                          />
                          <span className="input-suffix">days</span>
                        </div>
                        <div className="field-info">
                          <span className="field-info-item">Default: {leave.leaveCount} days</span>
                          {leave.approvalType && <span className="field-info-item">{leave.approvalType} approval</span>}
                        </div>
                        {leave.leaveRules && (
                          <div className="field-note">
                            <span className="material-icons">info</span>
                            <span>{leave.leaveRules}</span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  
                  <div className="form-field full-width">
                    <div className="info-box">
                      <span className="material-icons">lightbulb</span>
                      <div>
                        <p className="info-text">
                          <strong>Leave allocations</strong> are based on {formData.workingCountry} employment regulations. 
                          {!formData.gender && <span className="highlight-text"> Select gender to view gender-specific leave types.</span>}
                        </p>
                        <p className="link-text">
                          <span className="material-icons small-icon">open_in_new</span>
                          <a href="#" onClick={(e) => { e.preventDefault(); alert('Leave policy document would open here'); }}>
                            View complete leave policy
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          
          <div className="form-section">
            <div className="section-header">
              <span className="material-icons">checklist</span>
              <h3>Onboarding Checklist</h3>
            </div>
            
            <div className="section-content checklist-container">
              <div className="checklist-item">
                <input type="checkbox" id="emailSetup" />
                <label htmlFor="emailSetup">Email Setup</label>
              </div>
              <div className="checklist-item">
                <input type="checkbox" id="accessCard" />
                <label htmlFor="accessCard">Access Card</label>
              </div>
              <div className="checklist-item">
                <input type="checkbox" id="itEquipment" />
                <label htmlFor="itEquipment">IT Equipment</label>
              </div>
              <div className="checklist-item">
                <input type="checkbox" id="workstation" />
                <label htmlFor="workstation">Workstation Setup</label>
              </div>
              <div className="checklist-item">
                <input type="checkbox" id="systemAccess" />
                <label htmlFor="systemAccess">System Access</label>
              </div>
              <div className="checklist-item">
                <input type="checkbox" id="orientation" />
                <label htmlFor="orientation">Orientation Scheduled</label>
              </div>
            </div>
          </div>
          
          <div className="form-actions">
            <button 
              type="submit" 
              className="btn-primary" 
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Onboard Staff'}
            </button>
            <button
              type="button"
              className="btn-secondary"
              disabled={loading}
              onClick={() => {
                setFormData({
                  workingCountry: '', // Reset working country
                  name: '',
                  department: '',
                  grade: '',
                  role: '',
                  username: '',
                  location: '',
                  joinDate: today,
                  level: '',
                  email: '',
                  phoneNumber: '',
                  jobDescription: '',
                  manager: '',
                  employeeType: '',
                  designation: '',
                  // Reset all new fields
                  gender: '',
                  maritalStatus: '',
                  dateOfBirth: '',
                  currentAddress: '',
                  permanentAddress: '',
                  nationality: '',
                  governmentId: '',
                  bloodGroup: '',
                  hobbies: '',
                  yourPassion: '',
                  shortTermGoal: '',
                  longTermGoal: '',
                  primaryLanguage: '',
                  knownLanguage: ''
                });
                setSelectedTemplate('');
                
                // Reset checkboxes
                document.getElementById('emailSetup').checked = false;
                document.getElementById('accessCard').checked = false;
                document.getElementById('itEquipment').checked = false;
                document.getElementById('workstation').checked = false;
                document.getElementById('systemAccess').checked = false;
                document.getElementById('orientation').checked = false;
              }}
            >
              Clear Form
            </button>
          </div>
        </form>
      </div>
      
      {/* Template Selection Modal with proper alignment */}
      {showTemplateModal && (
        <div className="template-modal-overlay" onClick={handleOverlayClick}>
          <div className="template-modal" style={{
            display: 'flex',
            flexDirection: 'row'
          }}>
            <div className="template-modal-main" style={{ 
              display: 'flex',
              flexDirection: 'column',
              flex: '1',
              width: templatePreview ? 'calc(100% - 300px)' : '100%',
              overflow: 'hidden'
            }}>
              <div className="template-modal-header">
                <h2>Select a Department Template</h2>
                <button 
                  className="modal-close-btn" 
                  onClick={handleCloseModal}
                  aria-label="Close modal"
                >
                  <CloseIcon />
                </button>
              </div>
              
              <div className="template-modal-content">
                <p className="template-modal-description">
                  Choose a department template to quickly populate the onboarding form with department-specific defaults.
                </p>
                
                <div className="template-grid">
                  {departmentOptions
                    .filter(dept => dept.value) // Filter out empty options
                    .map(dept => (
                      <div 
                        key={dept.value} 
                        className={`template-card ${templatePreview?.id === dept.value ? 'active' : ''}`}
                        onClick={() => handlePreviewTemplate(dept.value)}
                        style={{
                          borderColor: departmentTemplates[dept.value]?.color || '#e5e7eb',
                          borderLeftWidth: '4px'
                        }}
                      >
                        <div 
                          className="template-card-icon" 
                          style={{backgroundColor: departmentTemplates[dept.value]?.color || '#e5e7eb'}}
                        >
                          {getDepartmentIcon(dept.value, departmentTemplates, BusinessIcon)}
                        </div>
                        <h3>{dept.label}</h3>
                        <p className="template-card-description">
                          {departmentTemplates[dept.value]?.description.substring(0, 60)}...
                        </p>
                      </div>
                    ))
                  }
                </div>
              </div>
              
              {!templatePreview && (
                <div className="template-modal-footer">
                  <button 
                    className="modal-close-btn-secondary" 
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            
            {/* Template Preview Panel */}
            {templatePreview && (
              <div className="template-preview-panel" style={{ 
                width: '300px',
                display: 'flex',
                flexDirection: 'column',
                borderLeft: '1px solid #e5e7eb',
                backgroundColor: '#fff',
                boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.05)'
              }}>
                <div 
                  className="template-preview-header" 
                  style={{
                    backgroundColor: templatePreview.color,
                    padding: '15px',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <h3 style={{ margin: 0 }}>{templatePreview.name} Template</h3>
                  <button 
                    className="preview-close-btn"
                    onClick={handleClosePreview}
                    aria-label="Close preview"
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#fff',
                      cursor: 'pointer',
                      padding: '5px'
                    }}
                  >
                    <CloseIcon />
                  </button>
                </div>
                
                <div className="template-preview-content" style={{
                  padding: '15px',
                  flexGrow: 1,
                  overflowY: 'auto'
                }}>
                  <div className="preview-section" style={{ marginBottom: '15px' }}>
                    <h4 style={{ margin: '0 0 5px 0' }}>Department Role</h4>
                    <p style={{ margin: '0' }}>{templatePreview.role || 'None specified'}</p>
                  </div>
                  
                  <div className="preview-section" style={{ marginBottom: '15px' }}>
                    <h4 style={{ margin: '0 0 5px 0' }}>Default Grade</h4>
                    <p style={{ margin: '0' }}>{templatePreview.grade || 'None specified'}</p>
                  </div>
                  
                  <div className="preview-section" style={{ marginBottom: '15px' }}>
                    <h4 style={{ margin: '0 0 5px 0' }}>Level</h4>
                    <p style={{ margin: '0' }}>{templatePreview.level || 'None specified'}</p>
                  </div>
                  
                  <div className="preview-section" style={{ marginBottom: '15px' }}>
                    <h4 style={{ margin: '0 0 5px 0' }}>Location</h4>
                    <p style={{ margin: '0' }}>{templatePreview.location || 'None specified'}</p>
                  </div>
                  
                  <div className="preview-section" style={{ marginBottom: '15px' }}>
                    <h4 style={{ margin: '0 0 5px 0' }}>Description</h4>
                    <p style={{ margin: '0' }}>{templatePreview.description || 'No description available'}</p>
                  </div>
                  
                  {templatePreview.requiredSkills && templatePreview.requiredSkills.length > 0 && (
                    <div className="preview-section" style={{ marginBottom: '15px' }}>
                      <h4 style={{ margin: '0 0 5px 0' }}>Required Skills</h4>
                      <ul className="preview-list" style={{ margin: '5px 0', paddingLeft: '20px' }}>
                        {templatePreview.requiredSkills.map((skill, idx) => (
                          <li key={idx} style={{ margin: '3px 0' }}>{skill}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  {templatePreview.equipment && templatePreview.equipment.length > 0 && (
                    <div className="preview-section" style={{ marginBottom: '15px' }}>
                      <h4 style={{ margin: '0 0 5px 0' }}>Standard Equipment</h4>
                      <ul className="preview-list" style={{ margin: '5px 0', paddingLeft: '20px' }}>
                        {templatePreview.equipment.map((item, idx) => (
                          <li key={idx} style={{ margin: '3px 0' }}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  {templatePreview.softwareAccess && templatePreview.softwareAccess.length > 0 && (
                    <div className="preview-section" style={{ marginBottom: '15px' }}>
                      <h4 style={{ margin: '0 0 5px 0' }}>Software Access</h4>
                      <ul className="preview-list" style={{ margin: '5px 0', paddingLeft: '20px' }}>
                        {templatePreview.softwareAccess.map((software, idx) => (
                          <li key={idx} style={{ margin: '3px 0' }}>{software}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                
                <div className="template-preview-actions" style={{
                  padding: '15px',
                  borderTop: '1px solid #e5e7eb',
                  display: 'flex',
                  justifyContent: 'space-between',
                  backgroundColor: '#f9fafb'
                }}>
                  <button 
                    className="apply-template-btn"
                    onClick={() => applyTemplate(templatePreview.id)}
                    style={{
                      backgroundColor: templatePreview.color,
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    Apply Template
                  </button>
                  <button 
                    className="cancel-template-btn"
                    onClick={handleClosePreview}
                    style={{
                      backgroundColor: '#fff',
                      color: '#333',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      fontWeight: 'normal'
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      
      {/* Submission Confirmation Dialog with enhanced information */}
      {showSubmitConfirmation && (
        <div className="submission-dialog-overlay">
          <div className="submission-dialog">
            <div className="submission-dialog-header">
              <h3>Confirm Onboarding</h3>
              <button 
                className="close-dialog-btn"
                onClick={() => setShowSubmitConfirmation(false)}
                aria-label="Close dialog"
              >
                <CloseIcon />
              </button>
            </div>
            <div className="submission-dialog-content">
              <h4>Staff Details</h4>
              <div className="confirmation-details">
                <div className="confirmation-detail-item">
                  <strong>Name:</strong> {formData.name}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Email:</strong> {formData.email}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Username:</strong> {formData.username}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Gender:</strong> {formData.gender}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Marital Status:</strong> {formData.maritalStatus}
                </div>
              </div>
              
              <h4>Department & Role Information</h4>
              <div className="confirmation-details">
                <div className="confirmation-detail-item">
                  <strong>Department:</strong> {departments.find(d => d.depId === formData.department)?.depName || 'Selected department'}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Role:</strong> {selectedRole?.roleName || 'Selected role'}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Reporting Manager:</strong> {reportingManagerStatus.managerName || reportingManagerId}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Grade:</strong> {formData.grade}
                </div>
                <div className="confirmation-detail-item">
                  <strong>Level:</strong> {levels.find(l => l.levelId === formData.level)?.levelName || 'Selected level'}
                </div>
              </div>

              <p className="confirmation-warning">This will create a new employee account with the provided information.</p>
            </div>
            <div className="submission-dialog-actions">
              <button
                className="btn-primary"
                onClick={handleConfirmedSubmit}
                disabled={submissionStatus.isSubmitting}
              >
                {submissionStatus.isSubmitting ? 'Processing...' : 'Confirm & Onboard'}
              </button>
              <button
                className="btn-secondary"
                onClick={() => setShowSubmitConfirmation(false)}
                disabled={submissionStatus.isSubmitting}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Submission Status Dialog */}
      {(submissionStatus.isSubmitting || submissionStatus.isComplete) && (
        <div className="submission-dialog-overlay">
          <div className="submission-dialog">
            <div className="submission-dialog-header">
              <h3>
                {submissionStatus.isSubmitting ? 'Processing' : 
                  submissionStatus.isSuccess ? 'Success!' : 'Error'}
              </h3>
              {!submissionStatus.isSubmitting && (
                <button 
                  className="close-dialog-btn"
                  onClick={handleCloseSubmissionDialog}
                  aria-label="Close dialog"
                >
                  <CloseIcon />
                </button>
              )}
            </div>
            <div className="submission-dialog-content">
              <div className="submission-status-icon">
                {submissionStatus.isSubmitting ? (
                  <CircularProgress className="spinning" />
                ) : submissionStatus.isSuccess ? (
                  <DoneAllIcon style={{ color: '#4caf50' }} />
                ) : (
                  <CancelIcon style={{ color: '#f44336' }} />
                )}
              </div>
              <h4>{submissionStatus.message}</h4>
              <div className="submission-status-steps">
                {submissionStatus.details.map((detail, index) => (
                  <div key={index} className="submission-status-step">
                    {submissionStatus.isSuccess ? (
                      <CheckCircleIcon style={{ color: '#4caf50' }} />
                    ) : (
                      <ErrorIcon style={{ color: '#f44336' }} />
                    )}
                    <span>{detail}</span>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Add this footer section for error details */}
            {!submissionStatus.isSubmitting && !submissionStatus.isSuccess && (
              <div className="submission-dialog-footer" style={{
                padding: '10px',
                borderTop: '1px solid #e5e7eb',
                backgroundColor: '#f9fafb'
              }}>
                <h4 style={{ margin: '0 0 10px 0', fontSize: '16px', color: '#333' }}>Error Details:</h4>
                <div className="error-details" style={{
                  maxHeight: '150px',
                  overflowY: 'auto',
                  padding: '10px',
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  border: '1px solid #ddd'
                }}>
                  {submissionStatus.details.map((detail, index) => (
                    <div key={index} className="error-detail" style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '8px'
                    }}>
                      <span className="material-icons" style={{
                        fontSize: '18px',
                        color: '#f44336',
                        marginRight: '8px'
                                           }}>error</span>
                      <span style={{
                        fontSize: '14px',
                        color: '#555'
                      }}>{detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
               </div>
      )}
    </div>
  );
};

export default CreatePeople;